import script from "./firmware-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./firmware-form.vue?vue&type=script&lang=ts&setup=true"

import "./firmware-form.vue?vue&type=style&index=0&id=336c9b9f&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336c9b9f"]])

export default __exports__